<div class="sidebar">
  <ul nz-menu nzMode="inline" class="main-nav">
    <li nz-menu-item routerLink="" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="ant-menu-item-selected">
      <i nz-icon nzType="home" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.home' | transloco }}</span>
    </li>
    <!-- <li nz-menu-item routerLink="plan" routerLinkActive="ant-menu-item-selected">
      <i nz-icon nzType="file-search" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.plan' | transloco }}</span>
    </li> -->
    <li nz-menu-item routerLink="schedule" routerLinkActive="ant-menu-item-selected">
      <i nz-icon nzType="calendar" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.schedule' | transloco }}</span>
    </li>
    <li nz-menu-group nzTitle="{{ 'sidebar.learning' | transloco }}" nzIcon="book">
      <ul>
        <li nz-menu-item routerLink="study/report-card" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="database" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.digitalReportCard' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="study/self-evaluation" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="line-chart" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.selfEvaluation' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="study/online" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="laptop" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.studyOnline' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="study/self-study" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="solution" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.selfStudy' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="study/homework" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="read" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.homework' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="study/club" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="team" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.club' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="speech" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="read" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.speech' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="chat" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="wechat" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.chat' | transloco }}</span>
        </li>
      </ul>
    </li>
    <li *ngIf="false" nz-menu-group nzTitle="Hoạt động khác" nzIcon="dingtalk">
      <ul>
        <li nz-menu-item routerLink="activity/extracurricular" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="car" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.extracurricularActivity' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="activity/health" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="medicine-box" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.health' | transloco }}</span>
        </li>
        <li nz-menu-item routerLink="activity/relax" routerLinkActive="ant-menu-item-selected">
          <i nz-icon nzType="play-square" nzTheme="outline"></i><span class="menu-item__label">{{ 'sidebar.relax' | transloco }}</span>
        </li>
      </ul>
    </li>
  </ul>
  <div class="logo">
    <img *ngIf="logo" class="logo__image" [src]="logo" alt="logo">
  </div>
</div>
